/**
 * MESSAGE
 * MSG
 */

/**
 *
 * 공통 Message
 * CRM : Confirm Messages   
 * ERR : Error Messages
 * INF : Information Messages
 * WRN : Warning Messages
 *   세부 )
 *      M : Message
 * MSG.show(MESSAGE.INF.M001, ["INF"]);
 * MSG.show(MESSAGE.WRN.I009, ["WRN","테스트 WRN"]);
 */
export var MESSAGE = {

	/**
     * Information Messages
     */
    INF : {
        M001 : "성공적으로 저장하였습니다."
      , M002 : "성공적으로 등록하였습니다."
      , M003 : "성공적으로 수정하였습니다."
      , M004 : "성공적으로 삭제하였습니다."
      , M005 : "성공적으로 출력되었습니다."
      , M006 : "@을(를) 성공적으로 저장하였습니다."
      , M007 : "@이(가) 삭제되었습니다."
      , M008 : "@을(를) 성공적으로 생성하였습니다."
      , M009 : "처리가 취소되었습니다."
      , M010 : "유효합니다."
      , M011 : "유효한 @입니다."
      , M012 : "@이(가) 아닙니다."
	  , M013 : "승인취소 되었습니다."
	  , M014 : "승인 처리되었습니다."
	  , M015 : "파일 다운로드가  완료되었습니다."
      , M016 : "파일의 내용이 정상적으로 등록되었습니다."
      , M017 : "성공적으로 분할해제하였습니다."
      , M018 : "성공적으로 처리 되었습니다."

      , B001 : "선택된 파일이 없습니다."
	  , B002 : "신탁지사 변경을 처리했습니다."
	  , B003 : "성공 : @건 \n실패 : @건 \n<실패내역> @"
	  , B004 : "@대행계약이 일괄종료 되었습니다."
	  , B005 : "@처리가 완료되었습니다."
	  , B006 : "@개이상은 선택할 수 없습니다."
  	  , B007 : "성공적으로 신청하였습니다."
	  , B008 : "해당기간에 편성이 없습니다."
	  , B009 : "선택하신 모든 편성이 @으로 이동되었습니다."
	  , B010 : "전월 처리 됩니다."
	  , B011 : "청약기간이 전월 및 당월에 모두 해당됩니다.\n'청약기간을 다시 선택하십시요."	
	  , B012 : "광고주형태가 @ (으)로 저장되었습니다." 		  
      , B013 : "제공자막이 수정되었습니다.\n제공자막변경신청 화면에서 업무연락신청하시기 바랍니다."
	  , B014 : "SMS 전송 완료하였습니다."
	  , B015 : "선택된 품목소재초수대행계약을 성공적으로 이동하였습니다."
	  , B016 : "정상적으로 취소처리되었습니다."

      , E001 : "결재 처리 되었습니다"
      , E002 : "반려 처리 되었습니다"
      , E003 : "결재요청 처리 되었습니다"
      , E004 : "발송되었습니다"
    },

    /**
     * Confirm Messages
     */
    CRM : {
        M001 : "저장하시겠습니까?"
      , M002 : "등록하시겠습니까?"
      , M003 : "수정하시겠습니까?"
      , M004 : "삭제하시겠습니까?"
      , M005 : "변경사항이 반영되지 않았습니다. 계속 하시겠습니까?"
      , M006 : "이미 존재하는 @ 입니다. 추가하시겠습니까?"
      , M007 : "@을(를) 삭제하시겠습니까?"
      , M008 : "@을(를) 생성하시겠습니까?"
      , M009 : "@을(를) 적용하시겠습니까?"
      , M010 : "취소하시겠습니까?"
      , M011 : "즉시 승인하시겠습니까?"
	  , M012 : "선택한 @을 @ 하시겠습니까?"
	  , M013 : "분할해제하시겠습니까?"
	  , M014 : "입력하신 정보로 발행합니다. \n\n 발행 전 확인 하셨나요?"
      , M015 : "복사하시겠습니까?"
      , M016 : "기존 데이터가 존재합니다. \n초기화 후 복사하시겠습니까?"
      // 주석
    //   , M017 : "초기화하시면 신규로 입력됩니다. \n초기화 후 청약 신청하시겠습니까?"
      , M017 : "첨부파일을 삭제하시겠습니까?"
      , M018 : "신청하시겠습니까?"
	  

      , B001 : "지정한 조건으로 자료를 신청하시겠습니까?"
      , B002 : "진행중인 대행계약품목도 종료됩니다.\n일괄종료 하시겠습니까?"
	  , B003 : "폐기된 소재입니다. \n 그래도 소재 이동 하시겠습니까?"
      , B004 : "@-@월 신탁으로 생성된 위약금을 취소하시겠습니까?"
	  , B005 : "대표광고주입니다. 전체삭제하시겠습니까?"
      , B006 : "선택한 자료 중 운행의뢰를 하지않은 자료를 삭제합니다. \n 삭제후에는 반드시 상대 광고회사에 삭제건에 대해 알려주시기 바랍니다!! \n 삭제하시겠습니까? \n"
	  , B007 : "소재 기입하시겠습니까?"
	  , B008 : "임시물 청약은 1개월 단위입니다. 그래도 처리 하시겠습니까?"
	  , B009 : "입력자의 소속과 신탁지사가 다릅니다. 그래도 처리하시겠습니까?"
	  , B010 : "대행기간 : @ ~ @ \n청약기간 : @ ~ @\n청약기간이 대행계약기간을 벗어납니다.\n그래도 등록하시겠습니까?"
	  , B011 : "이미 편성에 대해 청약하셨습니다.\n또 청약하시겠습니까?"
	  , B012 : "이미 청약된 판매 블럭이 @개 존재합니다.\n그래도 처리하시겠습니까?"		   
	  , B013 : "@을(를) @하시겠습니까?"
	  , B014 : "@하시겠습니까?"
	  , B015 : "@은(는) 계약기간이 @입니다!\n그래도 처리 하시겠습니까?"
	  , B016 : "최종거래일자가 종료되었습니다.\n진행중인 대행계약품목도 일괄종료 하시겠습니까?"
	  , B017 : "광고주명 : @ \n사업자번호 : @ \n주소 : @ \n입력한 내용이 맞습니까?\n맞으면 예(Y) 버튼을 클릭하세요."
	  , B018 : "광고회사명 : @ \n사업자번호 : @ \n주소 : @ \n입력한 내용이 맞습니까?\n맞으면 예(Y) 버튼을 클릭하세요."	  
	  , B019 : "간접광고 대행계약을 선택하였습니다. \n계속 하시겠습니까?"	 
	  , B020 : "편성종료처리하시겠습니까?"	
	  , B021 : "받는분 핸드폰 번호가 입력되지 않았습니다. 신청자 정보를 조회하시겠습니까?"
	  , B022 : "@ \n 이 연락처로 처리하시겠습니까?"
	  , B023 : "품목소재 대행계약 이동을 하시려면\n품목상세정보의 대행계약을 선택후 이동해야 합니다.\n품목소재 대행계약이동을 계속하시겠습니까?"
	  , B024 : "구좌를 종료하시겠습니까?"
	  , B025 : "편성종료해제처리하시겠습니까?"
	  
      , E001 : "결재 하시겠습니까?"
      , E002 : "반려 하시겠습니까?"
      , E003 : "결재요청 하시겠습니까?"
      , E004 : "고객명을 한 글자(영문 2자) 조회 시\n조회 시간이 오래걸릴수도 있습니다.\n조회하시겠습니까?"
      , E005 : "@이(가) 존재하지 않습니다.\n@를(을) 등록하시겠습니까?"
      , E006 : "종료된 대행계약입니다. \n그래도 선택하시겠습니까?"
      , E007 : "저장 후 출력하시겠습니까?"
      , E008 : "1년내에 신탁이 존재하는 고객입니다\n신규로 등록하시겠습니까?"
      , E009 : "1년이상 신탁이 없는 고객입니다\n기존으로 등록하시겠습니까?"
      , E010 : "폐업 처리 하시겠습니까"
      , E011 : "지정된 대상을 광고담당자로\n설정하시겠습니까?"
	  , E012 : "경유 확인 하시겠습니까?"
	  , E013 : "최근 수정된 일지입니다.\n부정확한 정보 입력시 10점의 마일리지가 차감됩니다.\n수정하시겠습니까?"
	  , E014 : "팀장의 대결자인 경우 결재요청시\n바로 결재완료 됩니다.\n결재 완료 하시겠습니까?"
	  , E015 : "항목을 수정하게되면 데이터가 초기화 됩니다.\n 변경하시겠습니까?"
	  , E016 : "퇴사자 처리 하시겠습니까?"  
	  , E017 : "해당 영업일자로 이미 작성된 건이 존재하여\n해당 건부터는 마일리지가 부여되지 않습니다\n계속하시겠습니까?" 
	  , E018 : "세분화별 고객생성시 1년정보 생성으로 인해\n시간이 다소( 5~6분정도) 소요됩니다.\n또한 기존건은 현재 생성건으로 대체됩니다\n계속 하시겠습니까?"
	  
 
    }, 

    /**
     * Error Messages
     */
    ERR : {
        M001 : "@은(는) 변경된 사항이 없습니다."
      , M002 : "@은(는) 필수 입력 항목입니다."
      , M003 : "해당되는 자료가 존재하지 않습니다."
      , M004 : "@은(는) 공백없이 입력하십시오."
      , M005 : "@은(는) @자리수만큼 입력하십시오."
      , M006 : "@은(는) @부터 @사이로 입력하십시오."
      , M007 : "@은(는) 숫자만을 입력하십시오."
      , M008 : "@은(는) 문자만을 입력하십시오."
      , M009 : "@은(는) 숫자와 문자만을 입력하십시오.(공백제외)"
      , M010 : "@은(는) 숫자와 문자만을 입력하십시오.(공백포함)"
      , M011 : "@은(는) @자 이상으로 입력하십시오."
      , M012 : "@은(는) @자 이하로 입력하십시오."
      , M013 : "@은(는) @ 이상으로 입력하십시오."
      , M014 : "@은(는) @ 이하로 입력하십시오."
      , M015 : "@은(는) 년도가 잘못되었습니다."
      , M016 : "@은(는) 유효한 주민등록번호가 아닙니다."
      , M017 : "@은(는) 유효한 사업자등록번호가 아닙니다."
      , M018 : "@은(는) 유효한 날짜가 아닙니다."
      , M019 : "@은(는) 월이 잘못되었습니다."
      , M020 : "@은(는) 일이 잘못되었습니다."
      , M021 : "@은(는) 시가 잘못되었습니다."
      , M022 : "@은(는) 분이 잘못되었습니다."
      , M023 : "@은(는) 초가 잘못되었습니다."
      , M024 : "@은(는) @년 @월 @일 이전이어야 합니다."
      , M025 : "@은(는) @년 @월 @일 이후이어야 합니다."
      , M026 : "@은(는) '@' 형식이어야 합니다.\n  - # : 문자 혹은 숫자\n  - h, H : 한글(H는 공백포함)\n  - A, Z : 문자(Z는 공백포함)\n  - 0, 9 : 숫자(9는 공백포함)"
      , M027 : "@은(는) @자리수만큼 입력하십시오. (한글은 @자리수)"
      , M028 : "@은(는) @자 이상으로 입력하십시오. (한글은 @자 이상)"
      , M029 : "@은(는) @자 이하로 입력하십시오. (한글은 @자 이하)"
      , M030 : "@은(는) "
      , M031 : "@의 @번째 데이터에서 "
      , M032 : "@은(는) 중복될 수 없습니다."
      , M033 : "@은(는) 다음 문자가 올 수 없습니다.\n@"
      , M034 : "페이지 설정이 잘못되었습니다."
      , M035 : "@페이지 이상은 출력할 수 없습니다"
      , M036 : "@은(는) 다음 문자만 올 수 있습니다.\n@"
      , M037 : "@은(는) 유효한 이메일 주소가 아닙니다."
      , M038 : "유효한 @가 아닙니다."
      , M039 : "시작일자를 종료일자 이전으로 선택[입력]하여 주십시오."
      , M040 : "패스워드가 일치하지 않습니다."
      , M041 : "@은(는) @할 수 없습니다."
      , M042 : "@은(는) 변경된 사항이 있습니다. \n변경사항을 저장 후 @을(를) 수행하십시오."
      , M043 : "유효하지 않는 @ 입니다.\n다시 입력하여주십시요"
      , M044 : "시작범위는 종료범위보다 작아야 합니다. :@"
      , M045 : "존재하지 않는 @입니다."
      , M046 : "오류가 발생하였습니다fg.\n관리자에게 문의하십시오."
      , M047 : "@은(는) @보다 작아야 합니다."
      , M048 : "@이(가) 존재하지 않습니다."
      , M049 : "오류가 발생하였습니다.\n처음부터 다시 시작하여 주십시오."
      , M050 : "@을(를) 실패하였습니다."
      , M051 : "해당조건의 @이(가) 존재하지 않습니다."
      , M052 : "@이(가) 누락되었습니다."
      , M053 : "@ 생성을 실패하였습니다."
      , M054 : "@을(를) 확인하여 주십시오."
      , M055 : "선택된 @이(가) 없습니다."
      , M056 : "@은(는) @ 보다 큰 값으로 입력하십시오."
      , M057 : "시작시간을 종료시간 이전으로 선택[입력]하여 주십시오."
      , M058 : "@은(는) 정수부를 @자 이하로 입력하십시오."
      , M059 : "@은(는) 소수부를 @자 이하로 입력하십시오."
      , M060 : "@은(는) @에 해당하는 번호를 입력하십시오.\n-형식 : @"
      , M061 : "@이(가) 존재합니다.\n@을(를) 먼저 삭제하세요."
      , M062 : "파일이 생성되지 않았습니다."
	  , M063 : "변경된 내역이 없습니다."
	  , M064 : "현재 소재 초수와 변경할 소재의 초수가 다릅니다\n확인후 다시 처리 하십시오."
	  , M065 : "현재 소재와 변경할 소재가 같습니다\n확인후 다시 처리 하십시오."
	  , M066 : "소재를 선택해 주십시오."
	  , M067 : "선택한 소재 초수와 조회하신 초수와 같아야 합니다."
	  , M068 : "선택된 데이터 중 소재 기입이 안된 데이터가 존재합니다. \n 소재를 기입한 후 신청 처리하십시오."
	  , M069 : "추가중에는 삭제 할 수 없습니다."
	  , M070 : "해당신탁지사에서만 삭제가능합니다"
	  , M071 : "@을(를) 먼저 입력하십시요."

      , B002 : "종료일자가 @ 최근종료일자가 아닙니다."
      , B003 : "방송되는 프로그램이 존재하므로 방송국을 삭제할 수 없습니다."
      , B004 : "광고주가 존재하면 유일한 광고주이력은 삭제할 수 없습니다. \n광고주를 삭제하면 유일한 광고주 이력은 자동 삭제됩니다."

      , B006 : "종료일자가 입력되지 않은 이력이 1건 이상 있습니다.\n종료일자를 입력하셔야 합니다."
      , B007 : "@은(는) @보다 커야 합니다."
      , B008 : "프로그램 장르 검색을 하기 위해 시작일자가 필요합니다.\n시작일자를 입력하십시오."
      , B009 : "시급 시간대가 이미 등록되어 있습니다.\n[@]번째 Row"
      , B010 : "유효한 시급 시간대가 존재하므로 이전 시급 시간대에 종료일자를 입력하셔야 합니다.\n[@]번째 Row"
      , B011 : "@은(는) @자리수만큼 입력하십시오."
      , B012 : "@은(는) @보다 클 수 없습니다."
      , B013 : "이동기간이 대행계약기간을 벗어났습니다!"
      , B014 : "@ 대행계약은 이동할 수 없습니다!"
      , B015 : "이동할 대행계약기간내역을 먼저 등록하세요!"
      , B016 : "소재변경신청이 있는 대행계약품목입니다.\n삭제하실 수 없습니다."
	  , B017 : "변경전 신탁지사와 변경후 신탁지사가 같습니다."
	  , B018 : "대행품목을 등록할 수 있는 대행계약기간이 없습니다!\n@"
	  , B019 : "해당신탁지사에서만 변경가능합니다"
	  , B020 : "이미 중지된 대행계약입니다."
	  , B021 : "마감처리되어 처리할 수 없습니다."
	  , B022 : "심의일자 미입력된 소재입니다."
	  , B023 : "대행계약을 맺은 광고주가 없습니다."
	  , B024 : "이미 사용 중으로 등록된 소재 입니다."
	  , B025 : "공통코드와 같은 값을 입력할 수 없습니다."	  
      , B026 : "처리년월이 조회하신 신탁월보다 작습니다."	 
	  , B027 : "@에 변경사항이 있습니다. 저장 후 작업하세요." 
      , B028 : "프로그램분류별등급에 해당하는 프로그램이 존재하는\n프로그램분류별등급 [@]건은 삭제할 수 없습니다."
      , B029 : "다음 자료는 동일한 프로그램분류별등급이 이미 존재합니다.\n수정 또는 삭제 후 다시 저장하십시요.\n\n프로그램대분류       : @\n프로그램중분류       : @\n프로그램소분류       : @\n프로그램세분류       : @\n시작일자                : @\n프로그램분류별등급 : @" 
      , B030 : "다음 자료는 @에 의해 기준가격이 계산된 편성이\n존재하므로 @를 삭제할 수 없습니다.\n\n 시작일자 : @"
      , B031 : "다음 자료는 동일한 장르별등급지수가 현재 운영중입니다.\n종료 처리후 신규 등록 가능합니다.\n\n시작일자     : @\n장르별등급 : @"
      , B032 : "다음 자료는 동일한 장르별등급지수가 이미 존재합니다.\n\n시작일자     : @\n장르별등급 : @"
      , B033 : "해당 월의 이월신탁 자료가 존재하는 광고회사가 없습니다."
	  , B034 : "삭제할 수 없는 자료입니다."
	  , B035 : "성수기/비수기 할인/할증률 기간이 중복되는 다음자료로 인해 저장할 수 없습니다.\n\n계약구분                적용월  시작일자       종료일자\n@"
	  , B036 : "성수기/비수기 할인/할증률 기간이 중복되는 다음자료로 인해 저장할 수 없습니다.\n\n적용월  시작일자       종료일자\n@"
      , B037 : "공동광고주명에 특수문자는 사용하실 수 없습니다."
      , B038 : "광고주코드 또는 광고주명, 둘 중 하나는 반드시 입력해야 합니다."
      , B039 : "무의뢰 광고주가 아닌 다음 광고주는 삭제 할 수 없습니다.\n@"
      , B040 : "키광고주는 복수선택할 수 없습니다."
   	  , B041 : "배분율의 합계는 100입니다."
   	  , B042 : "광고주코드의 7번째 자리는\n반드시 0 으로 입력하여야 합니다."
      , B043 : "법인 광고주의 법인번호 가 같아야 합니다.\n불일치 법인번호 : @ - @ "
      , B044 : "동일 법인번호 광고주와 광고주코드 앞 6자리가 같아야 합니다.\n광고주 : @ / @ "
	  , B045 : "시작일자가 운행중인 @ 종료일자보다 작습니다."
	  , B046 : "방송제한시간 소재입니다. 확인 후 입력바랍니다.!!!"
	  , B047 : "청약할 수 없습니다."
	  , B048 : "청약할 수 없는 계약상세구분 정보입니다.(일반계약)"
 	  , B049 : "청약/운행  삭제 및 중지는 해당 신탁지사에서만 가능합니다."
      , B050 : "삭제할 청약 내역이 없습니다."
      , B051 : "마감년월보다 이전일자는 입력하실 수 없습니다."
	  , B052 : "광고회사에 대한 대행계약이 존재하므로 광고회사를 삭제할 수 없습니다."
	  , B053 : "청약기간이 전월 및 당월에 모두 해당됩니다.\n'청약기간을 다시 선택하십시요."
	  , B054 : "마감처리 중에는 전월처리가 불가능합니다." 
	  , B055 : "과월신탁의 처리년월은 현재마감년월(@) 보다 커야합니다."
	  , B056 : "과월신탁은 운행구분이 전월방송이어야 합니다."	 
	  , B057 : "계산버튼을 눌러 청약금액을 먼저 계산해주십시요."
	  , B058 : "전파료 및 제작비를 재조정하여\n청약금액이 소재초수로 나누어질수있도록 하십시요."
	  , B059 : "[계산]버튼을 눌러 금액계산을 한 후 수동입력 가능합니다."
	  , B060 : "이미 청약된 판매 그룹이 @개 존재합니다.\n처리할 수 없습니다."
	  , B061 : "@"  // 프로시져나 함수에서 받아온 메시지를 모두 출력하기 위해 필요함	  
	  , B062 : "청약의 @일자(@)가 편성의 @일자(@) 보다 @."
	  , B063 : "횟수가 0입니다.\n청약일자를 변경하여 횟수를 입력해 주십시요."
	  , B064 : "광고주코드 또는 광고주명을 입력하세요."
	  , B065 : "@할 @내역이 없습니다."
      , B066 : "@은(는) @을(를) 넘을 수 없습니다."  
	  , B067 : "사용 종료된 업종입니다."
	  , B068 : "@이(가) 존재하므로\n@을(를) 변경할 수 없습니다."
	  , B069 : "@에 @되는 @이 존재합니다."	  
	  , B070 : "@관련 정보가 올바르지 않습니다.\n@"
	  , B071 : "편성의 @은(는) 검색조건의 @와 일치하여야 합니다."	
	  , B072 : "@ -> 소재종류가 다르므로 소재를 등록 할 수 없습니다."
	  , B073 : "@와 @의 @가 다릅니다\n확인후 다시 처리 하십시오."
	  , B074 : "최초사용일자가 심의일자보다 이후일자 이어야 합니다."
	  , B075 : "소재사용 시작일자가 최초사용일자보다 이후일자 이어야 합니다."
	  , B076 : "신규 입력을 하다가 삭제 할 수 없습니다.\n삭제하려면 삭제할 @를 다시 선택하세요."
	  , B077 : "중지되지 않은 대행계약입니다."
	  , B078 : "신청구분 정보가 정확하지 않습니다. \n신청구분 정보를 확인하세요."
	  , B079 : "이미 승인된 자료입니다. 처리할 수 없습니다."
	  , B080 : "선택하신 처리상태로 대행계약 신청은 작성되어 있습니다."
	  , B081 : "신규 광고주를 등록해주세요."
	  , B082 : "대행기간을 정확히 입력해주세요"
      , B083 : "@이(가) @보다 큽니다."
      , B084 : "광고회사 정보가 정확하지 않습니다. 처리할 수 없습니다."
	  , B085 : "@에 전송할 내용을 입력해주세요."
	  , B086 : "@ 정보가 조회되지 않습니다. 전산실로 문의 바랍니다."
	  , B087 : "다운로드할 파일이 없습니다."
	  , B088 : "다운로드 할 수 없는 소재입니다."
	  , B089 : "@ 선택가능합니다."
	  , B090 : "@ 특집불방, 연간불방, 이동불방, 기타이동불방 시 편성 Key 지역이 반드시 체크되어야 합니다."
	  , B091 : "@ 지역불방시 첫번째 불방지역은 체크되어서는 안됩니다."
	  , B092 : "@ -> 변경전 신탁지사와 변경후 신탁지사가 같습니다."
	  , B093 : "키광고주는 반드시 하나만 선택하십시오."
      , B094 : "부분마감 처리가 불가능합니다. \n해당기간에 부분마감여부 확인하세요."
        
      , E001 : "결재 중 오류가 발생했습니다.\n다시 결재해 주세요"
      , E002 : "반려 중 오류가 발생했습니다.\n다시 반려해 주세요"
      , E003 : "결재 요청 처리되지 않았습니다.\n재 요청해 주세요"
      , E004 : "면담자 선택은 기업을 지정해야 합니다"
      , E005 : "M.A.N의 예산,권한,요구의\n유/무는 필수 선택사항 입니다"
      , E006 : "@은(는) 필수 조회조건 입니다"
      , E007 : "@ 조회 범위는 @@만 가능합니다"
      , E008 : "@ 만 사용가능한\n페이지 입니다"
      , E009 : "대행계약이 존재하지 않습니다."
      , E010 : "@(을)를 먼저 등록해 주세요"
      , E011 : "@은(는) 하위데이터가 존재하여 삭제할 수 없습니다."
      , E012 : "@은(는) 전월부터 당월까지만 조회 가능합니다"
      , E013 : "@ 일자가 잘못되었습니다"
	  , E014 : "운행의뢰가 발송된 신청건은 삭제할 수 없습니다."
      , E015 : "조회된 @이(가) 없습니다"
      , E016 : "최소 1명의 면담자는\n지정되어야 합니다"
      , E017 : "조회 권한이 없습니다"
      , E018 : "동월의 출장내역만 조회 가능합니다\n ex) 2011-12-01 ~ 2011-12-31"
      , E019 : "@은(는) 당일을 \n넘길수 없습니다"
	  , E020 : "종료일자는 시작일자보다 작을수 없습니다."
	  , E021 : "@는\n잘못된 @ 형식입니다."
	  , E022 : "입력된 @가 번호 형식에 어긋납니다\n지역(통신사)번호 - 3~4자리 - 4자리"
	  , E023 : "이미 존재하는 @ 입니다\n등록대상 : @"
	  , E024 : "@은(는) @일 @만 조회 가능합니다"
	  , E025 : "20세 미만의 인물은 등록 불가능 합니다"
	  , E026 : "최소 1개의 출력항목은 선택하셔야 합니다"
	  , E027 : "파트장의 대결자만 가능합니다"
	  , E028 : "팀장의 대결자만 가능합니다"
	  , E029 : "조회기간은 2주를 넘을수 없습니다"
	  , E030 : "광고회사(전체선택해제)나 방송국을 입력하세요"
	  

    },

    /**
     * Warning Messages
     */
    WRN : {
        M001 : "저장할 데이터가 존재하지 않습니다.\n먼저 @검색을 하십시오."
      , M002 : "조회결과가 존재하지 않습니다."
      , M003 : "@을(를) 입력하십시오."
      , M004 : "삭제할 @이(가) 존재하지 않습니다."
      , M005 : "'+' 버튼을 누른 후 입력하십시오."
      , M006 : "'+'버튼을 누르신 후 @을(를) 입력하십시오."
      , M007 : "@을(를) 선택하십시오."
      , M008 : "검색한 데이터가 존재하지 않습니다.\n먼저 @검색을 하십시오."
      , M009 : "출력할 @이(가) 없습니다."
      , M010 : "@ 버튼을 이용하십시오."
      , M011 : "이미 존재하는 @입니다."
      , M012 : "@이(가) 반영되지 않았습니다."
      , M013 : "데이터를 전송 중 오류가 발생하였습니다.\n먼저 검색을 하신후 다시 시도해주시기 바랍니다."
      , M014 : "데이터를 전송 중 오류가 발생하였습니다.\n확인 후 다시 시도해주시기 바랍니다."
      , M015 : "저장할 데이터가 존재하지 않습니다.\n먼저 우편물을 등록 하십시오."
	  , M016 : "@ 정보는 영문이나 허용된 기호(,./-_()#~:;&<>@)으로 입력해 주세요."
	  , M017 : "@(을)를 함께 등록하셔야 합니다."
	  , M018 : "주문자 주소가 중복되었습니다. 주문자 전체주소만 등록하거나, \n주문자 우편번호주소와 상세주소만을 등록하십시오."
      , M019 : "잔여금액이 존재합니다."
      , M020 : "전체금액을 결제하셨습니다."
      , M021 : "마감자료가 일치하지 않습니다."
      , M022 : "마감취소사유를 입력하십시오."
      , M023 : "@이(가) 처리되지 않았습니다."
      , M024 : "삭제할 데이터를 선택하십시오."
	  , M025 : "삭제할 수 없는 @입니다."
	  , M026 : "소재 초수를 입력하십시오."
	  , M027 : "전체가 아닌 광고주를 입력하십시오."
	  , M028 : "@된 데이터 입니다. 수정할 수 없습니다."
	  , M029 : "운행중인 신탁지사의 @보다 작습니다."
	  , M030 : "동일한 @은(는) @ 할 수 없습니다."
	  , M031 : "구좌종료처리할 영업구좌목록을 선택하십시요."
	  , M032 : "편성종료일자가 올바르지 않습니다."
	  , M033 : "마감년도가 올바르지 않습니다."
      , M034 : "@번호를 전화번호 형식에 맞춰 입력하십시오.\n전화번호 형식 : 02-123-1234"
      , M035 : "분할할 데이터를 선택하십시오."

      , B001 : "새로 추가된 @를 저장하십시오."
      , B002 : "신탁마감이 완료된 대행기간만 조회가능합니다."
      , B003 : "추가해야 할 지역을 선택하십시오."
      , B004 : "시/군/구를 입력하십시오."
      , B005 : "년도를 입력하십시오."
      , B006 : "파일을 선택후 저장하십시오."
      , B007 : "@(을)를 먼저 저장하십시오."
      , B008 : "광고회사 또는 광고주 또는 편성 중 하나는 반드시 입력해야 합니다."
	  , B009 : "방송매체를 선택하십시오."
	  , B010 : "@(을)를 선택하십시오."
	  , B011 : "최근 2년이전 소재 입니다."
	  , B012 : "신규로 이동한 @만 선택할 수있습니다."
	  , B013 : "광고회사코드 8자리를 입력하십시오."
	  , B014 : "@목록과 @목록중 한곳만 선택하여 삭제하십시오."
	  , B015 : "값이 존재하지 않습니다. "
	  , B016 : "간접광고는 선택하실 수 없습니다.\n간접광고를 등록은 품목의 대행계약이 간접광고인 경우에만 가능합니다. "
	  , B017 : "동일한 방송사만 선택할 수 있습니다."
	  , B018 : "Upfront는 6개월, 12개월만 선택하실 수 있습니다."
	  , B019 : "광고가격은 전파료 금액보다 크거나 같아야 합니다."
	  , B020 : "품목을 입력하십시오"	  
	  , B021 : "간접광고시에는 @할 수 없습니다.\n 품목에서만 @ 가능합니다."
	  , B022 : "선택된 대행계약이 없어 대행계약 품목을 이동할 수 없습니다."
	  
	  , E001 : "소재 등록요청중인 항목입니다"
	  , E002 : "해당 일자는\n정상 영업일이 아닙니다\nex> 휴가, 해외출장등"
	  , E003 : "분기별 영업일지 비용청구 대상이 45건을 초과하였습니다\n영업일지가 미 청구로 진행됩니다"
	  , E004 : "분기별 영업일지 비용청구 대상이 45건을 초과하였습니다\n이후에 작성하는 영업일지는 일일출장비 미청구로 작성하셔야 합니다.\n일일출장비 미청구로 작성하시겠습니까?"
	  , E005 : "아직 경유를 거치지 않은 대상입니다\n파트장의 경유 확인 후 결재 가능합니다"
	  , E006 : "조회하신 인물은 퇴사자입니다.\n정보수정을 원하시면 CS경영팀의 운영자에게 문의하시기 바랍니다. !!!"
	  , E007 : "퇴사자는 대표로 선택 할 수 없습니다"
	  , E008 : "1회중지 삭제시 한중지에 의해 전월불방, 기타불방 \n데이타가 변경된 데이타는 복구되지 않습니다.\n주의하시기 바랍니다."
	}
};


/**
 * 공통 Message Show
 */
export var MSG = {
	/**
     * show(psID, psaArgs, psType);
     * 메세지박스 : ex) MSG.show(MESSAGE.INF.M006, ["INF"]); -> 기본 확인버튼(ok)을 가진 메세지박스 출력
     */
	show : function (psID, psaArgs, psType){
		return MsgBox.show(ComMsg.getMsg(psID, psaArgs), psType);		
	}
};



// -----------------util
/**
 * ValueUtil
 * Value 체크 및 형 변환
 */
var ValueUtil = {

  /**
   * isNull(puValue);
   * Null 여부 체크
   */
  isNull : function (puValue) {
      return (this.fixNull(puValue) === "");
  },

  /**
   * isNumber(psValue);
   * Number형 value인지 체크 : ex) ValueUtil.isNumber("1234.56") === true
   */
  isNumber : function (psValue) {
      var vnNum = Number(psValue);
      return isNaN(vnNum) === false;
  },

  /**
   * fixNull(puValue);
   * null이거나 정의되지 않은경우 ""로 반환
   */
  fixNull : function (puValue) {
      var vsType = typeof(puValue);
      if (vsType === "string" || (vsType === "object" && puValue instanceof String)) {
          puValue = puValue.trim();
      }
      return (puValue === null || puValue === "null" || puValue === "undefined") ? "" : String(puValue);
  },

  /**
   * fixBoolean(puValue);
   * Boolean형으로 반환
   */
  fixBoolean : function (puValue) {
      if (typeof(puValue) === "boolean" || puValue instanceof Boolean) {
          return puValue;
      }
      if (typeof(puValue) === "number" || puValue instanceof Number) {
          return puValue !== 0;
      }
      return (this.fixNull(puValue).toUpperCase() === "TRUE");
  },

  /**
   * fixNumber(puValue);
   * Number형으로 반환
   */
  fixNumber : function (puValue) {
      if (typeof(puValue) === "number" || puValue instanceof Number) {
          return puValue;
      }
      var vnNum = Number(this.fixNull(puValue));
      return isNaN(vnNum) ? 0 : vnNum;
  },

  /**
   * 소수점 자르기
   *
   * int  pnS    full 소수점
   * int  pnPos  full 소수점
   */
  trunc : function (pnS, pnPos) {
      var vsT = "0.0";
      var vsTail = "";
      var vaStrs = ("" + pnS).split(".");

      if (vaStrs.length > 1) {
          if (vaStrs[1].length >= pnPos)
              vsT = vaStrs[0] + "." + vaStrs[1].substring(0, pnPos);
          else {
              for (let i = 0; i < pnPos - vaStrs[1].length; i++){
                  vsTail += "0";
              }

              vsT = vaStrs[0] + "." + vaStrs[1] + vsTail;
          }
      }
      else {
          for (let i = 0; i < pnPos; i++){
              vsTail += "0";
          }

          vsT = vaStrs[0] + "." + vsTail;
      }

      return Number(vsT);
  }

};

/**
 * MsgBox
 * 메세지박스
 */
export var MsgBox = {

  /**
   * MsgBox Return Value Constants
   */
  IDOK     : 1,
  IDCANCEL : 2,
  IDABORT  : 3,
  IDRETRY  : 4,
  IDIGNORE : 5,
  IDYES    : 6,
  IDNO     : 7,

  /**
   * MsgBox Type Constants
   */
  MB_OK               : "ok",
  MB_OKCANCEL         : "okcancel",
  MB_ABORTRETRYIGNORE : "abortretryignore",
  MB_YESNOCANCEL      : "yesnocancel",
  MB_YESNO            : "yesno",
  MB_RETRYCANCEL      : "retrycancel",

  /**
   * Default Title
   */
  msDefaultTitle : null,

  /**
   * setDefaultTitle(psTitle);
   * 모든 메세지박스에 적용할 제목 설정, 최초 한번만 설정하면 유지됨 : ex) MsgBox.setDefaultTitle("우편접수시스템");
   */
  setDefaultTitle : function (psTitle) {
      this.msDefaultTitle = psTitle;
  },

  /**
   * show(psMsg, psType, psTitle);
   * 기본 메세지박스 : ex) MsgBox.show("안녕하세요!"); -> 기본 확인버튼(ok)을 가진 메세지박스 출력
   */
  show : function (psMsg, psType = this.MB_OK , psTitle) {

      if (psType === null) {
          psType = this.MB_OK;
      }
      //메시지 박스 타이틀 변경
      psTitle = "알림";

      if (psTitle) {
          if(psType === this.MB_OK){
              return alert(psMsg);
          }else if(psType === this.MB_OKCANCEL){
              return window.confirm(psMsg) ? this.IDOK : this.IDCANCEL;
          }else if(psType === this.MB_YESNO){
              return window.confirm(psMsg) ? this.IDYES : this.IDNO;
          }else{
              return window.confirm(psMsg);
          }
          //return model.msgboxT(psMsg, psTitle, psType);
      // 웹스퀘어 ? 
      // } else if (this.msDefaultTitle) {
      //     return model.msgboxT(psMsg, this.msDefaultTitle, psType);
      // } else {
      //     return model.msgbox(psMsg, psType);
      }
  },

  /**
   * showOkCancel(psMsg, psTitle);
   * 확인/취소 메세지박스 : ex) if (MsgBox.showOkCancel("진행하시겠습니까?") === MsgBox.IDCANCEL) return;
   */
  showOkCancel : function (psMsg, psTitle) {
      return this.show(psMsg, this.MB_OKCANCEL, psTitle);
  },

  /**
   * showAbort(psMsg, psTitle);
   * 중단/다시시도/무시 메세지박스 : ex) if (MsgBox.showAbort("잘못된 입력입니다.") === MsgBox.IDABORT) return;
   */
  showAbort : function (psMsg, psTitle) {
      return this.show(psMsg, this.MB_ABORTRETRYIGNORE, psTitle);
  },

  /**
   * showYesNoCancel(psMsg, psTitle);
   * 예/아니오/취소 메세지박스 : ex) if (MsgBox.showYesNoCancel("종료 전에 저장하시겠습니까?") === MsgBox.IDNO) return;
   */
  showYesNoCancel : function (psMsg, psTitle) {
      return this.show(psMsg, this.MB_YESNOCANCEL, psTitle);
  },

  /**
   * showYesNo(psMsg, psTitle);
   * 예/아니오 메세지박스 : ex) if (MsgBox.showYesNo("전송하시겠습니까?") === MsgBox.IDYES)
   */
  showYesNo : function (psMsg, psTitle) {
      return this.show(psMsg, this.MB_YESNO, psTitle);
  },

  /**
   * showRetry(psMsg, psTitle);
   * 다시시도/취소 메세지박스
   */
  showRetry : function (psMsg, psTitle) {
      return this.show(psMsg, this.MB_RETRYCANCEL, psTitle);
  }

};



/**
 * ComMsg
 * Common Message Library
 */


var ComMsg = {

  /**
   * Information Messages
   */
  INF : {
      M001 : "성공적으로 저장하였습니다."
      , M002 : "성공적으로 등록하였습니다."
      , M003 : "성공적으로 수정하였습니다."
      , M004 : "성공적으로 삭제하였습니다."
      , M005 : "@님 안녕하세요?"
      , M008 : "관리자에게 문의하십시오."
      , M009 : "성공적으로 출력되었습니다."
      , M010 : "@을(를) 성공적으로 저장하였습니다."
      , M011 : "@이(가) 삭제되었습니다."
      , M012 : "@을(를) 성공적으로 생성하였습니다."
      , M013 : "처리가 취소되었습니다."
      , M007 : "유효합니다."
      , M015 : "유효한 @입니다."
      , M016 : "@이(가) 아닙니다."
  },

  /**
   * Confirm Messages
   */
  CRM : {
      M001 : "저장하시겠습니까?"
      , M002 : "등록하시겠습니까?"
      , M003 : "수정하시겠습니까?"
      , M004 : "삭제하시겠습니까?"
      , M005 : "변경사항이 반영되지 않았습니다. 계속 하시겠습니까?"
      , M006 : "이미 존재하는 @ 입니다. 추가하시겠습니까?"
      , M008 : "@을(를) 삭제하시겠습니까?"
      , M009 : "@을(를) 생성하시겠습니까?"
      , M010 : "@을(를) 적용하시겠습니까?"
      , M011 : "취소하시겠습니까?"
      , M013 : "즉시 승인하시겠습니까?"
  },

  /**
   * Error Messages
   */
  ERR : {
      M001 : "@은(는) 변경된 사항이 없습니다."
      , M002 : "@은(는) 필수 입력 항목입니다."
      , M003 : "해당되는 자료가 존재하지 않습니다."
      , M004 : "@은(는) 공백없이 입력하십시오."
      , M005 : "@은(는) @자리수만큼 입력하십시오."
      , M006 : "@은(는) @부터 @사이로 입력하십시오."
      , M007 : "@은(는) 숫자만을 입력하십시오."
      , M008 : "@은(는) 문자만을 입력하십시오."
      , M009 : "@은(는) 숫자와 문자만을 입력하십시오.(공백제외)"
      , M010 : "@은(는) 숫자와 문자만을 입력하십시오.(공백포함)"
      , M011 : "@은(는) @자 이상으로 입력하십시오."
      , M012 : "@은(는) @자 이하로 입력하십시오."
      , M013 : "@은(는) @ 이상으로 입력하십시오."
      , M014 : "@은(는) @ 이하로 입력하십시오."
      , M015 : "@은(는) 년도가 잘못되었습니다."
      , M016 : "@은(는) 유효한 주민등록번호가 아닙니다."
      , M017 : "@은(는) 유효한 사업자등록번호가 아닙니다."
      , M018 : "@은(는) 유효한 날짜가 아닙니다."
      , M019 : "@은(는) 월이 잘못되었습니다."
      , M020 : "@은(는) 일이 잘못되었습니다."
      , M021 : "@은(는) 시가 잘못되었습니다."
      , M022 : "@은(는) 분이 잘못되었습니다."
      , M023 : "@은(는) 초가 잘못되었습니다."
      , M025 : "@은(는) @년 @월 @일 이후이어야 합니다."
      , M024 : "@은(는) @년 @월 @일 이전이어야 합니다."
      , M026 : "@은(는) '@' 형식이어야 합니다.\n  - # : 문자 혹은 숫자\n  - h, H : 한글(H는 공백포함)\n  - A, Z : 문자(Z는 공백포함)\n  - 0, 9 : 숫자(9는 공백포함)"
      , M027 : "@은(는) @자리수만큼 입력하십시오. (한글은 @자리수)"
      , M028 : "@은(는) @자 이상으로 입력하십시오. (한글은 @자 이상)"
      , M029 : "@은(는) @자 이하로 입력하십시오. (한글은 @자 이하)"
      , M030 : "@은(는) "
      , M031 : "@의 @번째 데이터에서 "
      , M032 : "@은(는) 중복될 수 없습니다."
      , M033 : "@은(는) 다음 문자가 올 수 없습니다.\n@"
      , M034 : "페이지 설정이 잘못되었습니다."
      , M035 : "@페이지 이상은 출력할 수 없습니다"
      , M036 : "@은(는) 다음 문자만 올 수 있습니다.\n@"
      , M037 : "@은(는) 유효한 이메일 주소가 아닙니다."
      , M038 : "유효한 @가 아닙니다."
      , M039 : "시작일자를 종료일자 이전으로 선택[입력]하여 주십시오."
      , M040 : "패스워드가 일치하지 않습니다."
      , M041 : "@은(는) @할 수 없습니다."
      , M042 : "@은(는) 변경된 사항이 있습니다. \n변경사항을 저장 후 @을(를) 수행하십시오."
      , M043 : "유효하지 않는 @ 입니다.\n다시 입력하여주십시요"
      , M045 : "시작범위는 종료범위보다 작아야 합니다. :@"
      , M046 : "존재하지 않는 @입니다."
      , M047 : "오류가 발생하였습니다.\n관리자에게 문의하십시오."
      , M048 : "@은(는) @보다 작아야 합니다."
      , M049 : "@이(가) 존재하지 않습니다."
      , M050 : "오류가 발생하였습니다.\n처음부터 다시 시작하여 주십시오."
      , M051 : "@을(를) 실패하였습니다."
      , M052 : "해당조건의 @이(가) 존재하지 않습니다."
      , M053 : "@이(가) 누락되었습니다."
      , M054 : "@ 생성을 실패하였습니다."
      , M055 : "@을(를) 확인하여 주십시오."
      , M056 : "선택된 @이(가) 없습니다."
      , M057 : "@은(는) @ 보다 큰 값으로 입력하십시오."
      , M058 : "시작시간을 종료시간 이전으로 선택[입력]하여 주십시오."
      , M059 : "@은(는) 정수부를 @자 이하로 입력하십시오."
      , M060 : "@은(는) 소수부를 @자 이하로 입력하십시오."
  },

  /**
   * Warning Messages
   */
  WRN : {
      M001 : "저장할 데이터가 존재하지 않습니다.\n먼저 @검색을 하십시오."
      , M002 : "조회결과가 존재하지 않습니다."
      , M003 : "@을(를) 입력하십시오."
      , M004 : "삭제할 @이(가) 존재하지 않습니다."
      , M005 : "'+' 버튼을 누른 후 입력하십시오."
      , M006 : "'+'버튼을 누르신 후 @을(를) 입력하십시오."
      , M007 : "@을(를) 선택하십시오."
      , M008 : "검색한 데이터가 존재하지 않습니다.\n먼저 @검색을 하십시오."
      , M009 : "출력할 @이(가) 없습니다."
      , M010 : "@ 버튼을 이용하십시오."
      , M011 : "이미 존재하는 @입니다."
      , M012 : "@이(가) 반영되지 않았습니다."
      , M013 : "데이터를 전송 중 오류가 발생하였습니다.\n확인 후 다시 시도해주시기 바랍니다."
  },

  /**
   * _verifyID(psID, psMsg);
   */
  _verifyID : function(psID, psMsg) {
      if (ValueUtil.isNull(psMsg)) {
          throw new window.InvalidArgumentException("[" + psID + "]는 존재하지 않습니다.");
      }
  },

  /**
   * getMsg(psMsg, psaArgs);
   */
  getMsg : function(psMsg, psaArgs) {
      if (psMsg === null || psMsg === "") return "";
      if (psaArgs === null) { return psMsg; }

      var vnIndex = 0;
      var vnCount = 0;
      while ((vnIndex = psMsg.indexOf("@", vnIndex)) !== -1) {
          if (psaArgs[vnCount] === null) psaArgs[vnCount] = "";
          psMsg = psMsg.substr(0, vnIndex) + String(psaArgs[vnCount]) + psMsg.substring(vnIndex + 1);
          vnIndex = vnIndex + String(psaArgs[vnCount++]).length;
      }
      return psMsg;
  },

  /**
   * alert(psMsg, psaArgs);
   */
  alert : function(psMsg, psaArgs) {
      MsgBox.show(this.getMsg(psMsg, psaArgs));
      alert(this.getMsg(psMsg, psaArgs));
  },

  /**
   * info(psID, psaArgs);
   * ex) ComMsg.info("M001"); -> ComMsg.INF.M001 : 성공적으로 저장하였습니다.
   */
  info : function(psID, psaArgs) {
      this._verifyID(psID, this.INF[psID]);
      this.alert(this.INF[psID], psaArgs);
  },

  /**
   * window.confirm(psID, psaArgs, psMsgBoxType);
   * ex) ComMsg.window.confirm("M001"); -> ComMsg.WRN.M001 : 저장하시겠습니까?
   */

  confirm : function(psID, psaArgs, psMsgBoxType) {
      this._verifyID(psID, this.CRM[psID]);
      if (ValueUtil.isNull(psMsgBoxType)) psMsgBoxType = MsgBox.MB_OKCANCEL;
      return MsgBox.show(this.getMsg(this.CRM[psID], psaArgs), psMsgBoxType);
  },


  /**
   * error(psID, psaArgs);
   * ex) ComMsg.error("M001", ["우편번호"]); -> ComMsg.ERR.M001 : 우편번호은(는) 변경된 사항이 없습니다.
   */
  error : function(psID, psaArgs) {
      this._verifyID(psID, this.ERR[psID]);
      this.alert(this.ERR[psID], psaArgs);
  },

  /**
   * warn(psID, psaArgs);
   * ex) ComMsg.warn("M003", ["발송인"]); -> ComMsg.WRN.M003 : 발송인을(를) 입력하십시오.
   */
  warn : function(psID, psaArgs) {
      this._verifyID(psID, this.WRN[psID]);
      this.alert(this.WRN[psID], psaArgs);
  }

};
